import styled from 'styled-components';
import ShipperFilter from './component';

import { selectStyles } from 'modules/filters/utils';

export default styled(ShipperFilter)`
  ${selectStyles}
`;
